import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import { Route, RouteProps } from 'react-router-dom';
import { ScaleLoader } from 'react-spinners';

import AuthenticatedContext, {
  AuthenticatedContextConsumer,
} from '../../context/AuthenticatedContext';
import LoginForm from '../login-form';
import styles from './index.module.scss';

const AuthRoute: React.FunctionComponent<RouteProps> = ({
  render,
  children,
  ...rest
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const context = useContext(AuthenticatedContext);

  useEffect(() => {
    let unmounted = false;
    if (context.isAuthenticated) {
      setIsLoading(false);
    } else {
      // URL直打ち時のログインチェック
      context
        .login()
        .catch(() => {
          // do nothing.
        })
        .finally(() => {
          if (!unmounted) {
            setIsLoading(false);
          }
        });
    }
    return () => {
      unmounted = true;
    };
  }, []);

  return (
    <AuthenticatedContextConsumer>
      {({ isAuthenticated }) => (
        <Route
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...rest}
          render={(props) => {
            // 認証がとおっている場合は正規のコンポーネントを表示する
            if (isAuthenticated) {
              if (children) {
                return children;
              }
              if (render) {
                return render(props);
              }
              // 設定がない場合は空コンポーネントかスルーするか...
              // return <></>;
            }
            // 認証確認待ち（useEffectでのログイン確認待ち）の場合はローディングコンポーネントを表示する
            if (isLoading) {
              return (
                <div className="text-center p-5">
                  <ScaleLoader color={styles.loaderColor} loading={isLoading} />
                </div>
              );
            }
            // 認証されていないようであればログインフォームを表示する
            return <LoginForm />;
          }}
        />
      )}
    </AuthenticatedContextConsumer>
  );
};

AuthRoute.propTypes = {
  children: PropTypes.element,
  render: PropTypes.func,
};
AuthRoute.defaultProps = {
  children: undefined,
  render: undefined,
};

export default AuthRoute;
